import type { FunctionComponent } from 'react';
import {
  ConstructKit,
  ConstructKitFoundations,
  MuseoSans,
} from '@rea-group/construct-kit-core';
import commercialOverrideTheme from './commercialOverrideTheme';
import {
  StyleSheetManager,
  version as styledComponentsVersion,
} from 'styled-components';

type Props = {
  darkMode?: boolean;
  foundationsOverride?: (
    baseFoundations: ConstructKitFoundations,
  ) => ConstructKitFoundations;
  fontOverride?: React.ReactNode | null;
  children: React.ReactNode;
};

const isStyledComponents6 = /^6\./.test(styledComponentsVersion);

const CommercialKit: FunctionComponent<Props> = ({
  darkMode,
  fontOverride = null,
  foundationsOverride = commercialOverrideTheme,
  children,
}) => (
  <StyleSheetManager
    {...(isStyledComponents6 && {
      enableVendorPrefixes: true,
    })}
  >
    <ConstructKit foundationsOverride={foundationsOverride} darkMode={darkMode}>
      {fontOverride || <MuseoSans />}
      {children}
    </ConstructKit>
  </StyleSheetManager>
);

export default CommercialKit;
